module.exports = __webpack_public_path__ + "static/img/6.e60c57f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/6.jpg
// module id = cRQl
// module chunks = 1